import React from "react";
import "./Loader.css";
export function Loader() {
  return (
    <div className="fx-center">
      <div className="loader"></div>
    </div>
  );
}
